import type { PokerSiteId } from '@poker-stats/contracts';

export type MiningUploadItem = {
  id: string;
  name: string;
  relativePath: string;
  size: number;
  status: 'pending' | 'uploading' | 'uploaded' | 'error';
  error?: string;
};

export type MiningUploadFile = { id: string; file: File };

export type StartMiningUploadPayload = {
  queueId: string;
  batchId: string;
  room: PokerSiteId;
  upload: { files: MiningUploadFile[]; signal: AbortSignal };
};

export function acceptsMiningFile(room: PokerSiteId, name: string): boolean {
  return name.toLowerCase().endsWith(room === 6 ? '.xml' : '.txt');
}
